import { Component, input } from "@angular/core";
import { ItemsHeaderBlock } from "../../../api/packbo/models/items-header-block";
import { FullHeaderComponent } from "./components/full-header/full-header.component";
import { LandingPageComponent } from "./components/landing-page/landing-page.component";
import { SimpleHeaderComponent } from "./components/simple-header/simple-header.component";
import { SubscriptionHeaderComponent } from "./components/subscription-header/subscription-header.component";

@Component({
    selector: "packbo-header-block",
    templateUrl: "./header-block.template.html",
    imports: [LandingPageComponent, SimpleHeaderComponent, FullHeaderComponent, SubscriptionHeaderComponent]
})
export class HeaderBlockComponent {
    public readonly headerBlock = input.required<ItemsHeaderBlock>();
}
